import React, { useState, useEffect } from 'react';
import { Smartphone, Activity, CheckCircle2, Loader2 } from 'lucide-react';

export default function AdminAnosim() {
  const [smsLogs, setSmsLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchLogs(); }, []);

  const fetchLogs = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch('/api/admin/anosim', { headers: { 'Authorization': `Bearer ${token}` } });
      if (response.ok) setSmsLogs(await response.json());
    } catch (err) { console.error(err); } finally { setIsLoading(false); }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-primary">Anosim SMS-Dienst</h1>
        <p className="text-muted-foreground">Überwachung der SMS-Verifizierungscodes für Ident-Prüfungen.</p>
      </div>

      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-border bg-slate-50/50 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Smartphone className="w-5 h-5 text-accent" />
            <h2 className="font-semibold text-primary">SMS Versand-Log</h2>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="flex items-center text-green-600 bg-green-50 px-2 py-1 rounded-md">
              <Activity className="w-4 h-4 mr-1" /> API Online
            </span>
          </div>
        </div>
        
        {isLoading ? (
          <div className="flex justify-center items-center h-64"><Loader2 className="w-8 h-8 animate-spin text-accent" /></div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse min-w-[700px]">
              <thead>
                <tr className="border-b border-border text-sm text-secondary bg-white">
                  <th className="p-4 font-semibold">Empfänger</th>
                  <th className="p-4 font-semibold">Tester</th>
                  <th className="p-4 font-semibold">Gesendeter Code</th>
                  <th className="p-4 font-semibold">Zeitstempel</th>
                  <th className="p-4 font-semibold">Zustellstatus</th>
                </tr>
              </thead>
              <tbody>
                {smsLogs.map((log, index) => (
                  <tr key={index} className="border-b border-border hover:bg-slate-50/50 transition-colors">
                    <td className="p-4 font-mono text-sm text-primary">{log.phone}</td>
                    <td className="p-4 text-sm text-secondary">{log.tester}</td>
                    <td className="p-4 font-mono font-bold tracking-widest text-secondary">{log.code}</td>
                    <td className="p-4 text-sm text-secondary">{log.time}</td>
                    <td className="p-4">
                      {log.status === 'delivered' ? (
                        <span className="flex items-center text-xs font-medium text-green-700">
                          <CheckCircle2 className="w-4 h-4 mr-1" /> Zugestellt
                        </span>
                      ) : (
                        <span className="flex items-center text-xs font-medium text-red-700">
                          <Activity className="w-4 h-4 mr-1" /> Fehlgeschlagen
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}